/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BidirectionalActionConfigCheckbox } from './BidirectionalActionConfigCheckbox';
import {
    BidirectionalActionConfigCheckboxFromJSON,
    BidirectionalActionConfigCheckboxFromJSONTyped,
    BidirectionalActionConfigCheckboxToJSON,
} from './BidirectionalActionConfigCheckbox';
import type { BidirectionalActionConfigDate } from './BidirectionalActionConfigDate';
import {
    BidirectionalActionConfigDateFromJSON,
    BidirectionalActionConfigDateFromJSONTyped,
    BidirectionalActionConfigDateToJSON,
} from './BidirectionalActionConfigDate';
import type { BidirectionalActionConfigPhoneNumber } from './BidirectionalActionConfigPhoneNumber';
import {
    BidirectionalActionConfigPhoneNumberFromJSON,
    BidirectionalActionConfigPhoneNumberFromJSONTyped,
    BidirectionalActionConfigPhoneNumberToJSON,
} from './BidirectionalActionConfigPhoneNumber';
import type { BidirectionalActionConfigPhoneNumberExtension } from './BidirectionalActionConfigPhoneNumberExtension';
import {
    BidirectionalActionConfigPhoneNumberExtensionFromJSON,
    BidirectionalActionConfigPhoneNumberExtensionFromJSONTyped,
    BidirectionalActionConfigPhoneNumberExtensionToJSON,
} from './BidirectionalActionConfigPhoneNumberExtension';
import type { BidirectionalActionConfigTextMessage } from './BidirectionalActionConfigTextMessage';
import {
    BidirectionalActionConfigTextMessageFromJSON,
    BidirectionalActionConfigTextMessageFromJSONTyped,
    BidirectionalActionConfigTextMessageToJSON,
} from './BidirectionalActionConfigTextMessage';
import type { BidirectionalActionConfigTime } from './BidirectionalActionConfigTime';
import {
    BidirectionalActionConfigTimeFromJSON,
    BidirectionalActionConfigTimeFromJSONTyped,
    BidirectionalActionConfigTimeToJSON,
} from './BidirectionalActionConfigTime';
import type { BidirectionalActionType } from './BidirectionalActionType';
import {
    BidirectionalActionTypeFromJSON,
    BidirectionalActionTypeFromJSONTyped,
    BidirectionalActionTypeToJSON,
} from './BidirectionalActionType';
import type { Question } from './Question';
import {
    QuestionFromJSON,
    QuestionFromJSONTyped,
    QuestionToJSON,
} from './Question';

/**
 * 
 * @export
 * @interface BidirectionalActionConfig
 */
export interface BidirectionalActionConfig {
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfig
     */
    is_enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfig
     */
    is_temporarily_disabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BidirectionalActionConfig
     */
    pushes_to_platform: boolean;
    /**
     * 
     * @type {BidirectionalActionType}
     * @memberof BidirectionalActionConfig
     */
    action_type: BidirectionalActionType;
    /**
     * 
     * @type {string}
     * @memberof BidirectionalActionConfig
     */
    connector: BidirectionalActionConfigConnectorEnum;
    /**
     * 
     * @type {Array<Question>}
     * @memberof BidirectionalActionConfig
     */
    questions: Array<Question>;
    /**
     * 
     * @type {BidirectionalActionConfigTextMessage}
     * @memberof BidirectionalActionConfig
     */
    text_message: BidirectionalActionConfigTextMessage;
    /**
     * 
     * @type {BidirectionalActionConfigTextMessage}
     * @memberof BidirectionalActionConfig
     */
    internal_text_message?: BidirectionalActionConfigTextMessage;
    /**
     * 
     * @type {BidirectionalActionConfigDate}
     * @memberof BidirectionalActionConfig
     */
    date?: BidirectionalActionConfigDate;
    /**
     * 
     * @type {BidirectionalActionConfigTime}
     * @memberof BidirectionalActionConfig
     */
    time?: BidirectionalActionConfigTime;
    /**
     * 
     * @type {BidirectionalActionConfigPhoneNumber}
     * @memberof BidirectionalActionConfig
     */
    phone_number?: BidirectionalActionConfigPhoneNumber;
    /**
     * 
     * @type {BidirectionalActionConfigPhoneNumberExtension}
     * @memberof BidirectionalActionConfig
     */
    phone_number_extension?: BidirectionalActionConfigPhoneNumberExtension;
    /**
     * 
     * @type {BidirectionalActionConfigCheckbox}
     * @memberof BidirectionalActionConfig
     */
    checkbox?: BidirectionalActionConfigCheckbox;
}


/**
 * @export
 */
export const BidirectionalActionConfigConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAscensionWi: 'EpicCare Link Ascension WI',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBaptistOneCare: 'EpicCare Link Baptist One Care',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkSelectMedical: 'EpicCare Link Select Medical',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkGuthrie: 'EpicCare Link Guthrie',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNch: 'EpicCare Link NCH',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOchsnerHealthNetwork: 'EpicCare Link Ochsner Health Network',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkProvidenceWashington: 'EpicCare Link Providence Washington',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkSalemHealth: 'EpicCare Link Salem Health',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'EpicCare Link University of Kansas St Francis',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfMississippiMedicalCenter: 'EpicCare Link University of Mississippi Medical Center',
    EpicCareLinkUniversityOfRochesterMedicine: 'EpicCare Link University of Rochester Medicine',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkSouthcoast: 'EpicCare Link Southcoast',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    EpicCareLinkJpsHealthNetwork: 'EpicCare Link JPS Health Network',
    EpicCareLinkPortneuf: 'EpicCare Link Portneuf',
    EpicCareLinkCheyenneRegionalMedicalCenter: 'EpicCare Link Cheyenne Regional Medical Center',
    EpicCareLinkUniversityMedicalCenter: 'EpicCare Link University Medical Center',
    EpicCareLinkCapeFearValley: 'EpicCare Link Cape Fear Valley',
    EpicCareLinkLexingtonMedicalCenter: 'EpicCare Link Lexington Medical Center',
    EpicCareLinkMedicalUniversityOfSouthCarolina: 'EpicCare Link Medical University of South Carolina',
    EpicCareLinkEssentiaHealth: 'EpicCare Link Essentia Health',
    EpicCareLinkUwHealth: 'EpicCare Link UW Health',
    EpicCareLinkNorthMississippiHealthServices: 'EpicCare Link North Mississippi Health Services',
    EpicCareLinkOregonHealthScienceUniversity: 'EpicCare Link Oregon Health & Science University',
    EpicCareLinkLcmcHealth: 'EpicCare Link LCMC Health',
    EpicCareLinkRwjBarnabas: 'EpicCare Link RWJ Barnabas',
    EpicCareLinkLovelaceHealthSystem: 'EpicCare Link Lovelace Health System',
    EpicCareLinkRochesterRegionalHealth: 'EpicCare Link Rochester Regional Health',
    EpicCareLinkAtlanticHealth: 'EpicCare Link Atlantic Health',
    EpicCareLinkBalladHealth: 'EpicCare Link Ballad Health',
    EpicCareLinkGreatRiver: 'EpicCare Link Great River',
    EpicCareLinkMountainsideMedicalCenter: 'EpicCare Link Mountainside Medical Center',
    EpicCareLinkUkHealthCare: 'EpicCare Link UK HealthCare',
    EpicCareLinkCghMedicalCenter: 'EpicCare Link CGH Medical Center',
    EpicCareLinkMosaicLifeCare: 'EpicCare Link Mosaic Life Care',
    EpicCareLinkGundersenHealth: 'EpicCare Link Gundersen Health',
    EpicCareLinkCoxHealth: 'EpicCare Link CoxHealth',
    EpicCareLinkSingingRiver: 'EpicCare Link Singing River',
    EpicCareLinkLickingMemorialHealth: 'EpicCare Link Licking Memorial Health',
    EpicCareLinkWakeMed: 'EpicCare Link WakeMed',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next',
    Roc: 'Roc'
} as const;
export type BidirectionalActionConfigConnectorEnum = typeof BidirectionalActionConfigConnectorEnum[keyof typeof BidirectionalActionConfigConnectorEnum];


/**
 * Check if a given object implements the BidirectionalActionConfig interface.
 */
export function instanceOfBidirectionalActionConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_enabled" in value;
    isInstance = isInstance && "is_temporarily_disabled" in value;
    isInstance = isInstance && "pushes_to_platform" in value;
    isInstance = isInstance && "action_type" in value;
    isInstance = isInstance && "connector" in value;
    isInstance = isInstance && "questions" in value;
    isInstance = isInstance && "text_message" in value;

    return isInstance;
}

export function BidirectionalActionConfigFromJSON(json: any): BidirectionalActionConfig {
    return BidirectionalActionConfigFromJSONTyped(json, false);
}

export function BidirectionalActionConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_enabled': json['is_enabled'],
        'is_temporarily_disabled': json['is_temporarily_disabled'],
        'pushes_to_platform': json['pushes_to_platform'],
        'action_type': BidirectionalActionTypeFromJSON(json['action_type']),
        'connector': json['connector'],
        'questions': ((json['questions'] as Array<any>).map(QuestionFromJSON)),
        'text_message': BidirectionalActionConfigTextMessageFromJSON(json['text_message']),
        'internal_text_message': !exists(json, 'internal_text_message') ? undefined : BidirectionalActionConfigTextMessageFromJSON(json['internal_text_message']),
        'date': !exists(json, 'date') ? undefined : BidirectionalActionConfigDateFromJSON(json['date']),
        'time': !exists(json, 'time') ? undefined : BidirectionalActionConfigTimeFromJSON(json['time']),
        'phone_number': !exists(json, 'phone_number') ? undefined : BidirectionalActionConfigPhoneNumberFromJSON(json['phone_number']),
        'phone_number_extension': !exists(json, 'phone_number_extension') ? undefined : BidirectionalActionConfigPhoneNumberExtensionFromJSON(json['phone_number_extension']),
        'checkbox': !exists(json, 'checkbox') ? undefined : BidirectionalActionConfigCheckboxFromJSON(json['checkbox']),
    };
}

export function BidirectionalActionConfigToJSON(value?: BidirectionalActionConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_enabled': value.is_enabled,
        'is_temporarily_disabled': value.is_temporarily_disabled,
        'pushes_to_platform': value.pushes_to_platform,
        'action_type': BidirectionalActionTypeToJSON(value.action_type),
        'connector': value.connector,
        'questions': ((value.questions as Array<any>).map(QuestionToJSON)),
        'text_message': BidirectionalActionConfigTextMessageToJSON(value.text_message),
        'internal_text_message': BidirectionalActionConfigTextMessageToJSON(value.internal_text_message),
        'date': BidirectionalActionConfigDateToJSON(value.date),
        'time': BidirectionalActionConfigTimeToJSON(value.time),
        'phone_number': BidirectionalActionConfigPhoneNumberToJSON(value.phone_number),
        'phone_number_extension': BidirectionalActionConfigPhoneNumberExtensionToJSON(value.phone_number_extension),
        'checkbox': BidirectionalActionConfigCheckboxToJSON(value.checkbox),
    };
}

